module.exports = __webpack_public_path__ + "static/media/Leopard Hunt [REDUCED].419d500b.m4v";